import React from 'react';
import 'classnames';
import { Breadcrumb } from '../../breadcrumbs/Breadcrumb.js';
import { Dialog } from '../../dialog/index.js';
import styles from './MaterialAssignmentDialogHeader.module.css.js';

function MaterialAssignmentDialogHeader({ title, breadcrumbName }) {
    return (React.createElement(Dialog.Header, { "data-testid": 'modal-header', title: title },
        React.createElement("div", { className: styles.container },
            React.createElement(Breadcrumb, { name: breadcrumbName, iconClassName: 'icon-assignment' }))));
}

export { MaterialAssignmentDialogHeader };
